import EmergencyFund from "./EmergencyFund"
import HomePurchase from "./HomePurchase"
import Retirement from "./Retirement"
import College from "./College"
import LifeInsurance from "./LifeInsurance"
import DebtPayoff from "./DebtPayoff"
import PrivateSchool from "./PrivateSchool"
import Other from "./Other"
import Car from "./Car"
import Charity from "./Charity"
import Caregiving from "./Caregiving"
import StudentLoanPayoff from "./StudentLoanPayoff"
import WorkPause from "./WorkPause"

export const goalWorksheets = {
  EmergencyFund,
  HomePurchase,
  Retirement,
  College,
  LifeInsurance,
  DebtPayoff,
  PrivateSchool,
  Other,
  Car,
  Charity,
  Caregiving,
  StudentLoanPayoff,
  WorkPause
}
